<template>
  <!--TODO: refactoring & simplify-->
  <div class="lego-manual-box-wrapper">
    <!-- [DESC] Component descriptor -->
    <div
      v-if="componentDesc.describe"
      class="lego-manual-box-wrapper__overall-desc"
      v-html="language==='en'?componentDesc.describeEn:componentDesc.describe"
    />
    <!-- [DESC] Component descriptor END -->
    <div
      ref="scrollContainer"
      class="sui-tab-box-type"
    >
      <!-- [SWITCH] Language selector -->
      <div class="lego-manual__segment">
        <div
          :class="{active:language==='ko'}"
          @click="language='ko'">
          Korean
        </div>
        <div
          :class="{active:language==='en'}"
          @click="language='en'"
        >
          English
        </div>
      </div>
      <!-- [SWITCH] Language selector END -->
      <ul
        ref="scrollContent"
        class="sui-tab-box-type__header"
      >
        <div
          ref="headerWrap"
          class="sui-tab-box-type__header__wrap"
        >
          <div
            ref="container"
            class="sui-tab-box-type__header__container"
          >
            <template v-for="(item,idx) in tabItems">
              <li
                v-if="itemCnt[item]"
                :key="idx"
                class="sui-tab-box-type__header-item"
                :class="{'sui-tab-box-type--active':tabidx==idx}"
                @click="tabidx=idx"
              >
                <span class="sui-tab-box-type__header-item__title">
                  {{ item }}({{ itemCnt[item] }})
                </span>
              </li>
            </template>
          </div>
        </div>
      </ul>
      <div
        v-if="tabidx==0"
        class="sui-tab-box-type__cont"
      >
        <slot />
      </div>
      <div
        v-if="tabidx==1"
        class="sui-tab-box-type__cont"
      >
        <prop-section
          :data="propsArr"
          :lang="language"
        />
      </div>
      <div
        v-if="tabidx==2"
        class="sui-tab-box-type__cont"
      >
        <slot-section
          :data="slotsArr"
          :lang="language"
        />
      </div>
      <div
        v-if="tabidx==3"
        class="sui-tab-box-type__cont"
      >
        <event-section
          :data="eventsArr"
          :lang="language"
        />
      </div>
      <div
        v-if="tabidx==4"
        class="sui-tab-box-type__cont"
      >
        <method-section
          :data="methodsArr"
          :lang="language"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { parser } from '@vuese/parser/dist/index.js';

import propSection from './SuiSub/SuiEhsManualProp';
import slotSection from './SuiSub/SuiEhsManualSlot';
import eventSection from './SuiSub/SuiEhsManualEvent';
import methodSection from './SuiSub/SuiEhsManualMethod';
/*
* 사용가능한 토큰:
* $v-model
* $deprecated
* $version: v0.0.0
* $abbr: original props name
* $hide
* $scope.name: description
* $arg: argument of method or event
* $(arg): optional argument of method or event
* $return: return value of method
* $default: default value of props. use when vuese parser cannot detect default value.
*
* 일반 description은 그냥 이렇게 적으면 됩니다. 줄바꿈은 적용되지 않습니다.
* <em>태그</em>를 사용할 수 있습니다. 간단한 코드블럭형태로 들어갑니다.
*
* # 영문 description은 이렇게 적으면 됩니다.
* # 앞에 #하나 붙은거 차이고, 동일하게 <em>태그</em>를 사용할 수 있습니다.
*/
export default {
  name: 'SuiShowcaseManualBox',
  components: {
    propSection,
    slotSection,
    eventSection,
    methodSection,
  },
  props: {
    rawFile: String,
    props: { type: Array, default: () => [] },
    slots: { type: Array, default: () => [] },
    events: { type: Array, default: () => [] },
    methods: { type: Array, default: () => [] },
    tokens: { type: Array, default: () => [] }, /* TODO Delete */
  },
  data() {
    return {
      // [DATA] Tab flags
      tabidx: 0, // sample
      tabItems: ['SAMPLES', 'PROPS', 'SLOTS', 'EVENTS', 'METHODS'],
      itemCnt: {},
      // [DATA] Manual data
      componentDesc: {},
      propsArr: [],
      slotsArr: [],
      eventsArr: [],
      methodsArr: [],
      tokensArr: [],
      mixin: [],
      language: 'ko',
    };
  },
  computed: {
  },
  watch: {
    /* rawFile: {
      immediate: true,
      handler(){
          this.parse();
          this.postProcess();
      }
    } */
  },
  created() {
    this.parse();
    this.postProcess();
    this.setItemCount();
  },
  methods: {
    setItemCount() {
      this.tabItems.forEach((item, idx) => {
        this.$set(this.itemCnt, item, this.getItemCount(idx));
      });
    },
    getItemCount(idx) {
      switch (idx) {
        case 0:
          // 필요시에 sample-box만 거르는 로직 추가
          return this.$slots.default.length;
        case 1:
          return this.propsArr.length;
        case 2:
          return this.slotsArr.length;
        case 3:
          return this.eventsArr.length;
        case 4:
          return this.methodsArr.length;
        default:
          return -1;
      }
    },
      parse(raw = this.rawFile) {
          let parserRes;
          try {
              let __restore = console.trace;
              console.trace = ()=>{};
              parserRes = parser(raw);
              console.trace = __restore;
          } catch(e) {
              console.error(e)
          }
          this.componentDesc.describe=[];
          this.componentDesc.describeEn=[];
          if(parserRes.componentDesc && parserRes.componentDesc.default) {
              this.componentDesc.describe = parserRes.componentDesc.default;
            // this.componentDesc.describe = parserRes.componentDesc.default||[];
          }
          this.propsArr = parserRes.props||[];
          this.slotsArr = parserRes.slots||[];
          this.eventsArr = parserRes.events||[];
          this.methodsArr = parserRes.methods||[];
          this.mixins = parserRes.mixIns||[]
      },
      postProcess() {
          this.tokenParse(this.componentDesc);
          for(let item of this.propsArr) {
              if(this.isArray(item.type)) {
                  item.type = item.type.join(' | ');
              }
              item.tags = [];
              item.describeEn = [];
              item.args=[];
              item.return = '';
              if(!item.bindings) {
                  item.bindings={}
              }
              this.tokenParse(item);
          }
          this.slotsArr = this.slotsArr.filter(it => it.target == 'template');
          for(let item of this.slotsArr) {
              item.tags=[];
              item.describeEn = [];
              item.args=[];
              item.return = '';
              if(!item.bindings) {
                  item.bindings={}
              }
              this.tokenParse(item);
          }
          for(let item of this.eventsArr) {
              item.tags=[];
              item.describeEn = [];
              item.args=[];
              item.return = '';
              if(!item.bindings) {
                  item.bindings={}
              }
              this.tokenParse(item);
          }
          for(let item of this.methodsArr) {
              item.tags=[];
              item.describeEn = [];
              item.args=[];
              item.return = '';
              if(!item.bindings) {
                  item.bindings={}
              }
              this.tokenParse(item);
          }
          /* for(let item of this.mixins) {
              if(item.mixIn === 'legoValidatorMixin') {
                  this.propsArr=this.propsArr.concat([]);
                  this.eventsArr=this.eventsArr.concat([]);
                  this.methodsArr=this.methodsArr.concat([]);
              }
          } */
      },
      tokenParse(item) {
          let tmp;
          if(this.isArray(item.describe)) {
              let tokens = item.describe.filter(v=>v.startsWith('$'));
              for(let token of tokens) {
                  if(token.startsWith('$ver') || token.startsWith('$version'))
                      item.version = token.slice(token.indexOf(':')+1).replace(/[\s\r\n]/g,'');
                  else if(token.startsWith('$v-model'))
                      // item.tags.push('v-model');
                      item.tags.push(token.slice(token.indexOf(':')+1).replace(/[\r\n]/g,''));
                  else if(token.startsWith('$deprecated'))
                      item.deprecated='deprecated';
                  else if(token.startsWith('$abbr')){
                      item.hide=true;
                      tmp = token.slice(token.indexOf(':')+1).replace(/[\s\r\n]/g,'');
                      this.propsArr.map(obj=>{if(obj.name===tmp) {obj.abbr = item.name}});
                  }
                  else if(token.startsWith('$hide'))
                      item.hide = true;
                  else if(token.startsWith('$scope'))
                      item.bindings[token.slice(7,token.indexOf(':')+1)]=token.slice(token.indexOf(':')).replace(/[\r\n]/g,'');
                  else if(token.startsWith('$arg'))
                      item.args.push(token.slice(token.indexOf(':')+1).replace(/[\r\n]/g,''));
                  else if(token.startsWith('$(arg)'))
                      item.args.push('#'+token.slice(token.indexOf(':')+1).replace(/[\r\n]/g,''));
                  else if(token.startsWith('$return'))
                      item.return = token.slice(token.indexOf(':')+1).replace(/[\r\n]/g,'');
                  else if(token.startsWith('$default'))
                      item.default = token.slice(token.indexOf(':')+1).replace(/[\r\n]/g,'');
              }
              tokens = item.describe.filter(v=>v.startsWith('#'));
              for(let token of tokens) {
                  item.describeEn.push(token.slice(token.slice(1).search(/[^\s\r\n]/)+1));
              }
              item.describe = item.describe.filter(v=>v.search(/^[$#]/)!==0).join('<br/>');
              item.describeEn = item.describeEn.join('<br/>');
              if(item.describe && !item.describeEn) {
                  item.describeEn = 'Not provide english description. :(';
              }
          } else if(typeof(item.describe) === 'string') {
              item.describe = item.describe.split(/[\r\n]{1,2}[\s]*/);
              this.tokenParse(item);
          }
      },
      isArray(arr) {
          return arr && Array.isArray(arr)
      },
      badgeColor(str) {
          return 'lego-badge__custom-color';
          /*/
          if(typeof(str) === 'object' && str.version){
              if(this.versions.indexOf(str.version) !== -1) {
                  return 'lego-badge__custom-color';
              }
              
          }
          if(str==='deprecated'){return 'warning';}
          if(str==='v-model'){return 'processing';}
          if(str==='required'){return 'error';}
          return 'default'/**/
      }
  }
}
</script>

<style scoped>
.sui-tab-box-type {overflow:initial;}
.sui-tab-box-type__cont {padding-top:20px;overflow:initial;}
</style>
<style lang="scss">
.lego-manual__segment {
    &{position:absolute; top:0;right:0;border:1px solid #CCC;display:flex;font-size:14px;font-weight:bold;z-index:100;}
    >div{padding:2px;width:65px;cursor:pointer;text-align: center;}
    >div:hover {background:#E9ECF7;}
    >div.active {background:#2460A4;color:#FFF;}
}

.lego-manual-box__item__value__badge {
    background:#336AFF;color:#FFF;border-radius:20px;display:inline-block;
    padding:1px 12px 1px 8px;font-size:11px;
    line-height:initial;
}
.lego-manual-box__item__value__badge.required {background:#e91e63;}

.lego-manual-box-wrapper{position:relative;width:100%;}
.lego-manual-box-wrapper__overall-desc{
    position:relative;
    font-size: 14px;
    margin-bottom: 8px;
    background: #e8f3f9;
    padding: 10px 20px 10px 35px;
    border: 1px solid #2196F3;
    border-radius: 5px;}
.lego-manual-box-wrapper__overall-desc::before {
    $sz : 16px;
    content: ' ';
    // background: url("../../../../assets/images/ic_message_info_38x38.png") center center no-repeat;
    background-size: $sz $sz;
    position:absolute;top:calc(50% - 8px);left:10px;width:$sz;height:$sz;
}
    
.lego-manual-box {width:100%;margin-bottom:32px;}
.lego-manual-box .lego-tab__content {padding: 0;}
.lego-manual-box__row {
    position:relative;/*display:flex;*/
    padding:8px 0;
    border-bottom: 1px solid #EAEAEA;
}
.lego-manual-box__row.empty {color:#979797;height:100px;display:flex;align-items:center;justify-content: center;}
$__left-area__width: 240px;
.lego-manual-box__left-area {
    position:relative;display:inline-flex;flex-wrap: wrap;
    width:$__left-area__width;
}
.lego-manual-box__right-area {
    position:relative;display:inline-flex;flex-wrap: wrap;
    width:calc(100% - #{$__left-area__width});
}

.lego-manual-box__item {
    &{position:relative;margin-bottom: 8px;padding-right:20px;}
    &.name        {flex: 0 0 100%;}
    &.tag         {flex: 0 0 100%;}
    &.type        {flex: 0 0 (100% * 2 / 3);}
    &.default     {flex: 0 0 (100% / 3);}
    &.description {flex: 0 0 100%;}
    &.slot-scope  {flex: 0 0 100%;}
    &.argument    {flex: 1 0 (100% * 2 / 3);}
    &.return      {flex: 0 0 (100% * 1 / 3);}
}
.lego-manual-box__item__label {
    position:relative;
    font-size: 12px;
    color: #767676;
    text-decoration: underline;
}
.lego-manual-box__item__value {
    position: relative;
    font-size: 14px;
    line-height: 21px;
    font-weight: normal;
    color: #333;
}
.name .lego-manual-box__item__label {
    &{text-decoration: unset;}
    .lego-badge-container {text-decoration: underline;}
}
.name .lego-manual-box__item__value {
    &{color: #2460A4;font-size:20px;line-height:32px;word-break:break-all;}
    span {font-weight: normal;font-size:12px;line-height:18px;color: #959595;}
}
.default .lego-manual-box__item__value--undefined {
    font-weight: normal;
    color: #959595;
}
.description .lego-manual-box__item__value {
    &{font-weight: normal;}
    em {
        font-size: 12px;
        line-height:18px;
        background-color: #EAEAEA;
        color: #333;
        font-style: unset;
        border-radius: 2px;
        padding: 2px 4px;
    }
}
.slot-scope, .argument { .lego-manual-box__item__value {
    &{font-size: 14px;}
    .lego-badge-container {display:block;}
    .lego-badge-container {margin-top:8px;}
    .lego-badge {height: 18px; line-height:18px; font-size:14px;}
}}
.lego-manual-box__item {
    .lego-badge-container {display: inline-block;}
    .lego-badge {font-size: 10px;font-weight:normal;margin-right:0;}
    .lego-badge__status {margin-left:0;};
}

.lego-manual-box__item__label .lego-badge__custom-color .lego-badge {
    background-color: #2460A4;
    color: #FFF;
}
</style>